function createRange(min, max) {
    const range = [];
    for (let i = min; i <= max; i++) {
        range.push(i);
    }
    return range;
}
function clamp(n, min, max) {
    if (n < min)
        return min;
    if (n > max)
        return max;
    return n;
}
function computeRadius(a, b) {
    return Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2)) / 2;
}

export { clamp, computeRadius, createRange };
